// extracted by mini-css-extract-plugin
export default {"root":"heroSection_root__FZ1bM"};